import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "./AuthContext";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const { user } = useAuth();
  const [constants, setConstants] = useState(null);
  const [trips, setTrips] = useState([]);
  const [selectedTripId, setSelectedTripId] = useState(localStorage.getItem("jastip_trip") || "all");

  const loadTrips = useCallback(async () => {
    try {
      const r = await api.get("/trips");
      setTrips(r.data);
    } catch (e) {
      console.error("Gagal memuat daftar trip:", e);
    }
  }, []);

  useEffect(() => {
    if (!user) return;
    api.get("/meta/constants").then((r) => setConstants(r.data)).catch(() => {});
    loadTrips();
  }, [user, loadTrips]);

  const selectTrip = (id) => {
    setSelectedTripId(id);
    localStorage.setItem("jastip_trip", id);
  };

  const tripParam = selectedTripId && selectedTripId !== "all" ? selectedTripId : undefined;

  return (
    <AppContext.Provider value={{ constants, trips, loadTrips, selectedTripId, selectTrip, tripParam }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
